import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './AbstractSubmission.css';
import Navbar from './Navbar';
import Footer from './Footer';

const AbstractSubmission = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [abstracts, setAbstracts] = useState([]);
  const [userPapers, setUserPapers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [userPayments, setUserPayments] = useState([]);
  const [loadingPayments, setLoadingPayments] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    const uid = sessionStorage.getItem('uid');

    if (token && uid) {
      setIsAuthenticated(true);

      // Fetch abstracts
      axios
        .get(`https://api.rescons.in/get-abstracts-by-user/${uid}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setAbstracts(res?.data?.abstracts || []);
        })
        .catch((err) => {
          console.error("Error fetching abstracts:", err);
        });

      // Fetch user papers
      axios
        .get(`https://api.rescons.in/api/papers/user`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setUserPapers(res?.data?.papers || []);
        })
        .catch((err) => {
          console.error("Error fetching papers:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const fetchUserPayments = async () => {
      const uid = sessionStorage.getItem('uid');
      if (uid) {
        try {
          const response = await axios.get(`https://api.rescons.in/user-info/${uid}`);
          if (response.data && response.data.payments) {
            setUserPayments(response.data.payments);
          }
        } catch (error) {
          console.error("Error fetching user payments:", error);
        }
      }
      setLoadingPayments(false);
    };

    fetchUserPayments();

    // Listen for payment updates
    const handlePaymentUpdate = (event) => {
      const uid = sessionStorage.getItem('uid');
      if (uid && event.detail.uid === uid) {
        fetchUserPayments();
      }
    };

    window.addEventListener('paymentUpdated', handlePaymentUpdate);

    return () => {
      window.removeEventListener('paymentUpdated', handlePaymentUpdate);
    };
  }, []);

  const handleRedirect = () => navigate('/contact');

  const handleSubmitRedirect = () => {
    if (isAuthenticated) {
      navigate('/submit-abstract');
    } else {
      setErrorMessage('Redirecting you to login...');
      setTimeout(() => navigate('/login-signup'), 2000);
    }
  };

  const handleRegisterRedirect = () => {
    if (isAuthenticated) {
      navigate('/registration-form');
    } else {
      setErrorMessage('Please log in before registering for the conference.');
      setTimeout(() => {
        navigate('/login-signup?redirect=/registration-form');
      }, 2000);
    }
  };

  const handleViewStatus = (abstractCode) => {
    navigate(`/abstract-submission-status?code=${abstractCode}`);
  };

  const handleViewPaperStatus = (paperCode) => {
    navigate(`/paper-submission-status?code=${paperCode}`);
  };

  const handleDownloadTemplate = async () => {
    try {
      const fileUrl = `${process.env.PUBLIC_URL}/assets/Paper-Template.docx`;
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error('Failed to fetch template');
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'Paper-Template.docx';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Failed to download template:', error);
      window.location.href = `${process.env.PUBLIC_URL}/assets/Paper-Template.docx`;
    }
  };

  const getPaperForAbstract = (abstractCode) => {
    return userPapers.find(paper => paper.abstractCode === abstractCode);
  };

  return (
    <>
      <Navbar />
      <div className='abstract-submission'>
        {/* Registration Pending Banner */}
        {isAuthenticated && !loadingPayments && userPayments && !userPayments.some(payment => payment.status === 'captured' || payment.status === 'paid') && (
          <div>
          </div>
        )}

        {/* <div className="marquee-banner" >
          <div className="marquee-text">
            <span>Abstract Submission Closed</span>

            &nbsp;&nbsp;&nbsp; • Acceptance notifications will be sent by <span class="highlight-flash">25th June 2025</span>

            &nbsp;&nbsp;&nbsp;  • Thank you for your interest in submitting your work.
            &nbsp;&nbsp;&nbsp;  • Please keep visiting this website for information on future events and conferences.
            <br />          </div>
        </div> */}

        <div className="abstract-submission-wrapper">
          {/* === Header === */}
          <header className="abstract-header">
            <h1>Paper Submission</h1>
            <br />
            <p className="abstract-description">
              <br></br>Submit your full paper for STIS-V 2025. Please ensure you follow the paper template and guidelines. <br /> Paper submissions are now open and will close on <span className="highlight-flash">September 25, 2025</span>.
            </p>
          </header>



          {/* ADDED OVER */}

          {/* <aside class="slanted-ribbon" aria-label="Upcoming Deadlines">
            <div class="content">
              <ul>
                <li tabindex="0">
                  <div class="deadline-title"><s style={{ textDecorationColor: "black", textDecorationThickness: "2px" }}>Abstract Submission</s></div>
                  <div class="cal-cell">
                    <div class="cal-month"><s style={{ textDecorationColor: "black", textDecorationThickness: "2px" }}>May</s></div>
                    <div class="cal-day"><s style={{ textDecorationColor: "black", textDecorationThickness: "2px" }}>31</s></div>
                  </div>
                  <span class="hover-icon">»</span>
                </li>

                <li tabindex="0">
                  <div class="deadline-title">Acceptance Notification</div>
                  <div class="cal-cell">
                    <div class="cal-month">Jun</div>
                    <div class="cal-day">25</div>
                  </div>
                  <span class="hover-icon">»</span>
                </li>
                <li tabindex="0">
                  <div class="deadline-title">Deadline For Full Paper Submission</div>
                  <div class="cal-cell">
                    <div class="cal-month">Sep</div>
                    <div class="cal-day">25</div>
                  </div>
                  <span class="hover-icon">»</span>
                </li>

              </ul>
            </div>
          </aside> */}

          <div className="highlight-flash1">
            <strong>Note: One registered author can present only one paper/poster</strong>
          </div>

          <section className="tutorial-videos-section">
  <h3 className="tutorial-videos-title">Video Tutorials</h3>
  <div className="tutorial-videos-grid">
    {/* Paper Submission */}
    <div className="tutorial-card">
      <h4>Paper Submission</h4>
      <div className="video-wrapper">
        <video controls>
          <source src="/stis2025/assets/Paper Submission.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>

    {/* Check Status & Upload Revised Manuscript */}
    <div className="tutorial-card">
      <h4>Check Status & Upload Revised Manuscript</h4>
      <div className="video-wrapper">
        <video controls>
          <source src="/stis2025/assets/Revised.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>

    {/* Get Invitation Letter */}
    {/* <div className="tutorial-card">
      <h4>Get Invitation Letter</h4>
      <div className="video-wrapper">
        <video controls>
          <source src="/stis2025/assets/Letter.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div> */}
  </div>
</section>

          {/* === Abstract Actions === */}
          <section className="abstract-actions">
            {isAuthenticated && (
              <>


                {/* Action Buttons - Moved Up */}
                <div className="button-group center-buttons">
                  <button className="btn btn-primary" onClick={() => navigate('/paper-submission')}>
                    Submit Paper
                  </button>
                  <button className="btn btn-secondary" onClick={handleRegisterRedirect}>
                    Proceed to Payment
                  </button>
                </div>
              </>
            )}

            {/* This part always visible */}
            {!isAuthenticated ? (
              <>
                <h2>To submit papers and view their status, please log in to your account.</h2>
                <div className="button-group center-buttons">
                  <button className="btn btn-secondary" onClick={handleSubmitRedirect}>
                    Login
                  </button>
                  <button className="btn btn-primary" onClick={handleRegisterRedirect}>
                    Proceed to Payment
                  </button>
                </div>
              </>
            ) : null}

            {errorMessage && <p className="error-message centered-text">{errorMessage}</p>}
          </section>

          {/* === Additional Info Sections === */}
          <div className="submission-info-sections">
            {/* Three Cards Row */}
            <div className="three-cards-row">
              {/* Need Help Card - Left */}
              <div className="info-card your-submissions-card">
                <h3 className="card-title">Your Submissions</h3>
                {isAuthenticated ? (
                  <>
                    {loading ? (
                      <p>Loading your papers...</p>
                    ) : abstracts.length > 0 ? (
                      <div className="submissions-content">
                        {abstracts
                          .filter(abs => {
                            // Check for approved status in abstractSubmissions or direct status
                            if (abs.abstractSubmissions && abs.abstractSubmissions.length > 0) {
                              return abs.abstractSubmissions.some(sub => sub.status === 'Approved');
                            }
                            return abs.status === 'Approved' || abs.status === 'Accepted';
                          })
                          .map((abs, index) => {
                            const paper = getPaperForAbstract(abs.abstractCode);
                            return (
                              <div key={index} className="abstract-entry">
                                <strong>{abs.title || `Paper ${index + 1}`}</strong><br />
                                Code: <code>{abs.abstractCode}</code><br />
                                <div className="abstract-actions-buttons">
                                  <button
                                    className="btn btn-primary small"
                                    onClick={() => handleViewStatus(abs.abstractCode)}
                                  >
                                    View Abstract Status
                                  </button>
                                  {paper && (
                                    <button
                                      className="btn btn-secondary small"
                                      onClick={() => handleViewPaperStatus(paper.paperCode)}
                                    >
                                      View Paper Status
                                    </button>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    ) : (
                      <p>You have not submitted any papers yet.</p>
                    )}
                  </>
                ) : (
                  <p>Please log in to view your submissions.</p>
                )}
              </div>
              {/* <div className="info-card associated-journals-card">
                <h3 className="card-title">Associated Journals</h3>
                <p className="card-description">Selected papers may be considered for publication in the following journals:</p>
                <div className="journal-list-inline">
                  <span className="journal-item">🔹 Ironmaking & Steelmaking</span>
                  <span className="journal-item">🔹 Materials and Manufacturing Processes</span>
                  <span className="journal-item">🔹 Surface Engineering</span>
                  <span className="journal-item">🔹 Steel Research International</span>
                </div>
              </div> */}

              {/* Your Submissions Section - Center */}
              {/* <div className="info-card your-submissions-card">
                <h3 className="card-title">Your Submissions</h3>
                {isAuthenticated ? (
                  <>
                    {loading ? (
                      <p>Loading your papers...</p>
                    ) : abstracts.length > 0 ? (
                      <div className="submissions-content">
                        {abstracts
                          .filter(abs => {
                            // Check for approved status in abstractSubmissions or direct status
                            if (abs.abstractSubmissions && abs.abstractSubmissions.length > 0) {
                              return abs.abstractSubmissions.some(sub => sub.status === 'Approved');
                            }
                            return abs.status === 'Approved' || abs.status === 'Accepted';
                          })
                          .map((abs, index) => {
                            const paper = getPaperForAbstract(abs.abstractCode);
                            return (
                              <div key={index} className="abstract-entry">
                                <strong>{abs.title || `Paper ${index + 1}`}</strong><br />
                                Code: <code>{abs.abstractCode}</code><br />
                                <div className="abstract-actions-buttons">
                                  <button
                                    className="btn btn-primary small"
                                    onClick={() => handleViewStatus(abs.abstractCode)}
                                  >
                                    View Abstract Status
                                  </button>
                                  {paper && (
                                    <button
                                      className="btn btn-secondary small"
                                      onClick={() => handleViewPaperStatus(paper.paperCode)}
                                    >
                                      View Paper Status
                                    </button>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    ) : (
                      <p>You have not submitted any papers yet.</p>
                    )}
                  </>
                ) : (
                  <p>Please log in to view your submissions.</p>
                )}
              </div> */}

              {/* Paper Template Card - Right */}
              <div className="info-card template-card">
                <h3 className="card-title">Paper Template</h3>
                <p className="card-description">
                  Authors are requested to use the official template for preparing the full paper. Click the button below to download the paper template.
                </p>
                <div className="template-download-container">
                  
                  <button className="help-btn" onClick={handleDownloadTemplate}>
                    Download Paper Template
                  </button>
                  
                  <span className="new-badge">New</span>
                </div>
              </div>

              <div className="info-card associated-journals-card">
                <h3 className="card-title">Associated Journals</h3>
                <p className="card-description">Selected papers may be considered for publication in the following journals:</p>
                <div className="journal-list-inline">
                  <span className="journal-item">🔹 Ironmaking & Steelmaking</span>
                  <span className="journal-item">🔹 Materials and Manufacturing Processes</span>
                  <span className="journal-item">🔹 Surface Engineering</span>
                  <span className="journal-item">🔹 Steel Research International</span>
                </div>
              </div>
            </div>
          </div>
          <div className="divider">
            <h2>Need Help?</h2>
            <p className="card-description" style={{ textAlign: 'center' }}>
              For submission-related queries, contact us at: stis.mte@iisc.ac.in or click below to reach support.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button className="help-btn1" onClick={handleRedirect}>Contact Support</button>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <Footer />
    </>
  );
};

export default AbstractSubmission;
